module.exports = __webpack_public_path__ + "static/img/SABINO_GUISU.90e33b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/SABINO_GUISU.jpg
// module id = mabu
// module chunks = 1